export default theme => ({
  root: {
    marginBottom: theme.spacing(3)
  },
  field: {
    margin: theme.spacing(3)
  },
  customTextField: {
    width: '100%',
    maxWidth: '100%',
    marginRight: 0
  },
  textField: {
    width: '100px',
    maxWidth: '100%',
    marginRight: 0
  },
  boldCell: {
    fontWeight: 'bold',
  },
  coefHeaderCell: {
    width: '120px',
  },
  customCell: {
    padding: '6px 5px',
  }
});
